export default "__VITE_ASSET__BwotzGnk__"